import {
    switchMap,
    distinctUntilChanged,
    debounceTime,
    filter,
} from 'rxjs/operators';
import {
    AfterViewInit,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
} from '@angular/core';

import { TrainingsTitlePipe } from '../_shared/trainings-title.pipe';
import { TrainingsActivePipe } from '../_shared/trainings-active.pipe';

import { Training, TrainingService } from '../../_services';
import { JhiLanguageHelper } from '../../shared';
import { Subject } from 'rxjs';

@Component({
    selector: 'jhi-trainings',
    templateUrl: 'training.component.html',
    styleUrls: ['training.component.scss'],
    providers: [TrainingsTitlePipe, TrainingsActivePipe],
})
export class TrainingComponent implements OnInit, AfterViewInit {
    static languageStatic: string;
    private static _search: string = '';

    @ViewChild('searchInput')
    private searchInput: ElementRef;

    /* Also used for detail */
    account: any;
    error: string;
    success: string;
    trainings: Training[];
    active: boolean = true;
    language: string;

    searchTrainingsSubject = new Subject<string>();

    constructor(
        private trainingsService: TrainingService,
        private languageHelper: JhiLanguageHelper
    ) {}

    get search(): string {
        return TrainingComponent._search;
    }

    set search(search: string) {
        TrainingComponent._search = search;
    }

    ngOnInit() {
        this.language = this.languageHelper.getCurrentLang();
        this.searchTrainingsSubject
            .pipe(
                filter((keyword) => keyword.length >= 2),
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((keyword: string) =>
                    this.trainingsService.search(keyword, {
                        language: this.language,
                    })
                )
            )
            .subscribe((trainings) => (this.trainings = trainings));
    }

    searchTrainings() {
        this.searchTrainingsSubject.next(this.search);
    }

    activeClicked() {
        this.active = !this.active;
    }

    convertCurrency(currency) {
        if (!currency) {
            return '?!';
        }

        if (currency.toLowerCase() === 'euro') {
            return '€';
        }

        return '';
    }

    ngAfterViewInit(): void {
        this.searchInput.nativeElement.focus();
    }

    switchLanguage(language: string): void {
        this.language = language;
        this.searchTrainings();
    }

    getTitle(training: Training) {
        if (!this.language || !training.trainingMetadatas) {
            return training.title;
        }
        let trainingMetadata = training.trainingMetadatas.find(
            ({ language }) => language === this.language
        );
        return trainingMetadata ? trainingMetadata.title : training.title;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/training/training.component.ts